import { useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
// import { Fragment, useContext, useEffect, useState } from "react";
import { Fragment, useContext, useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import swal from "sweetalert";
import ct from "countries-and-timezones";
import countryToCurrency from "country-to-currency";
import "./BusinessPlanAi.css";
import axios from "axios";
import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";

import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentBusinessPlan from "../Gallery/ContentBusinessPlan";
import { Button } from "@mui/material";

// Build country list from countries-and-timezones (same as Dashboard)
const allCountriesObj = ct.getAllCountries();
const countryNameToIso = {};
Object.values(allCountriesObj).forEach((c) => {
    countryNameToIso[c.name] = c.id; // e.g. "India" -> "IN"
});

const COUNTRIES = Object.values(allCountriesObj)
    .map((country) => country.name)
    .sort();

// Get currency code for a country name (same as Dashboard)
const getCurrencyForCountry = (countryName) => {
    const iso = countryNameToIso[countryName];
    if (iso && countryToCurrency[iso]) {
        return countryToCurrency[iso];
    }
    return "";
};

// Budget range options — amounts will be prefixed with the detected currency
const BUDGET_RANGES = [
    { min: 0, max: 5000 },
    { min: 5000, max: 25000 },
    { min: 25000, max: 50000 },
    { min: 50000, max: 100000 },
    { min: 100000, max: 250000 },
    { min: 250000, max: 1000000 },
    { min: 1000000, max: Infinity },
];

export default function BusinessPlanAi() {
    const [selectedCountry, setSelectedCountry] = useState("");
    const [currency, setCurrency] = useState("");
    const [businessIdea, setBusinessIdea] = useState("");
    const [budgetRange, setBudgetRange] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [exchangeRates, setExchangeRates] = useState({});

    const [suggestedIdea, setSuggestedIdea] = useState("");
    const [checkingPrompt, setCheckingPrompt] = useState(false);
    const [auditChecked, setAuditChecked] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);

    const promptTimeoutRef = useRef(null);

    const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
    const navigate = useNavigate();

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const res = await fetch(
                    "https://backend.whalesai.com/api/v1/api-rate"
                );

                const data = await res.json();

                const rates = {};

                data.forEach((item) => {
                    rates[item.quote] = item.rate;
                });

                rates["USD"] = 1;

                setExchangeRates(rates);
            } catch (error) {
                console.error("Failed to load exchange rates", error);
            }
        };

        fetchRates();
        window.scrollTo(0, 0);
    }, []);

    const roundBudget = (amount) => {
        return Math.round(amount / 100) * 100;
    };

    const formatAmount = (amount) => {
        return amount.toLocaleString(undefined, {
            maximumFractionDigits: 0,
        });
    };
    const getBudgetLabel = (range) => {
        const rate = exchangeRates[currency] || 1;

        const min = roundBudget(range.min * rate);

        if (range.max === Infinity) {
            return `Over ${currency} ${formatAmount(min)}`;
        }

        const max = roundBudget(range.max * rate);

        return `${currency} ${formatAmount(min)} - ${currency} ${formatAmount(max)}`;
    };

    // Auto-detect country on mount (same approach as Dashboard)
    useEffect(() => {
        const detectCountry = async () => {
            // If user already has a saved country in their profile, use that
            const savedCountry = AIuser?.country;
            if (savedCountry) {
                setSelectedCountry(savedCountry);
                setCurrency(
                    AIuser?.currency || getCurrencyForCountry(savedCountry) || "SGD"
                );
                return;
            }

            try {
                const res = await fetch(
                    "https://backend.aisuperbot.org/api/v1/location"
                );
                if (!res.ok) throw new Error("Location API failed");
                const json = await res.json();
                const countryName = json?.data?.country || "";

                const matched = COUNTRIES.find(
                    (c) => c.toLowerCase() === countryName.toLowerCase()
                );

                const finalCountry = matched || countryName || "Singapore";
                const finalCurrency = getCurrencyForCountry(finalCountry) || "SGD";

                setSelectedCountry(finalCountry);
                setCurrency(finalCurrency);
            } catch (err) {
                console.log("Location detection failed:", err);
                setSelectedCountry("Singapore");
                setCurrency("SGD");
            }
        };
        detectCountry();
    }, [AIuser]);

    const handleCountryChange = (e) => {
        const country = e.target.value;
        setSelectedCountry(country);
        const newCurrency = getCurrencyForCountry(country) || "";
        setCurrency(newCurrency);
        // Reset budget range when country changes since currency changed
        setBudgetRange("");
    };

    const handleClear = () => {
        setBusinessIdea("");
        setBudgetRange("");
    };

    const parseBudgetRange = (rangeStr) => {
        const [minStr, maxStr] = rangeStr.split("-");
        return {
            min: Number(minStr),
            max: maxStr === "Infinity" ? Infinity : Number(maxStr),
        };
    };

    const selectedRange = parseBudgetRange(budgetRange);
    const rate = exchangeRates[currency] || 1;

    const baseCredit = 415;
    const credit = auditChecked ? baseCredit + 84 : baseCredit;
    //cost of 415 credit is 5 usd
    //cost of 84 credit is 1.01 usd
    const creditCostUSD = auditChecked ? 5 + 1.01 : 5;


    // const handleSubmitCredits = async () => {
    //     const deductedCredits = AIuser.credits - credit;
    //     await axios
    //         .put(
    //             "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
    //             { email: AIuser?.email, credits: deductedCredits },
    //             {
    //                 headers: {
    //                     authorization: `Bearer ${localStorage.getItem("aiUser")}`,
    //                 },
    //             },
    //         )
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setUserRefetch(!userRefetch);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };

    const checkBusinessIdeaPrompt = async (value) => {
        if (!value?.trim()) {
            setSuggestedIdea("");
            return;
        }

        try {
            setCheckingPrompt(true);

            const authToken = localStorage.getItem("aiUser");

            const res = await axios.post(
                "https://backend.whalesai.com/api/v1/prompt-checker/check",
                {
                    prompt: value,
                    aiService: "business-plan-ai",
                },
                {
                    headers: {
                        authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (res?.data?.success) {
                setSuggestedIdea(res.data.data.suggested_prompt);
            }
        } catch (error) {
            console.log("Prompt checker error:", error);
        } finally {
            setCheckingPrompt(false);
        }
    };

    const handleGenerate = async () => {
        if (AIuser.credits < credit) {
            Swal.fire({
                text: "You don't have enough credits! Please buy credits to continue.",
                icon: "error",
                confirmButtonText: "Buy",
                customClass: {
                    popup: "modal_class_success",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate("/purchase");
                }
            });
            return;
        }

        if (!selectedCountry) {
            Swal.fire({
                text: "Please select a country.",
                icon: "warning",
                confirmButtonText: "Ok",
                customClass: { popup: "modal_class_success" },
            });
            return;
        }

        if (!businessIdea.trim()) {
            Swal.fire({
                text: "Please enter your business idea.",
                icon: "warning",
                confirmButtonText: "Ok",
                customClass: { popup: "modal_class_success" },
            });
            return;
        }

        if (!budgetRange) {
            Swal.fire({
                text: "Please select a startup budget range.",
                icon: "warning",
                confirmButtonText: "Ok",
                customClass: { popup: "modal_class_success" },
            });
            return;
        }

        setIsLoading(true);

        try {
            const budget = `${roundBudget(selectedRange.min * rate)}-${selectedRange.max === Infinity ? "Infinity" : roundBudget(selectedRange.max * rate)}`;

            const payload = {
                credit,
                country: selectedCountry,
                currency: currency,
                idea: businessIdea,
                budget,
                audit: auditChecked,
            };

            const response = await fetch(
                "https://backend.whalesai.com/api/v1/business-plan-ai/generate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                    },
                    body: JSON.stringify(payload),
                },
            );
            const res = await response.json();

            if (res.success) {
                // handleSubmitCredits();
                setUserRefetch(!userRefetch)
                setTimeout(() => {
                    const wrapper = document.createElement("div");
                    wrapper.innerHTML = `<p></p> <p class="text-white">We are generating the Business Plan for you. We will send the business plan to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

                    swal({
                        content: wrapper,
                        icon: "success",
                        button: "Close",
                        className: "modal_class_success",
                    }).then(() => {
                        swal({
                            icon: "success",
                            button: {
                                text: "Refreshing the page for you",
                                className: "bg-danger",
                            },
                            confirmButtonClass: "bg-danger",
                            className: "modal_class_success",
                            closeOnClickOutside: false,
                        });

                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    });
                }, 1000);
            }

        } catch (error) {
            console.error("Error generating Business Plan:", error);

            Swal.fire({
                text: error.message || "Something went wrong!",
                icon: "error",
                confirmButtonText: "Ok",
                customClass: {
                    popup: "modal_class_success",
                },
            });
        } finally {
            setIsLoading(false);
        }
    };

    const isFormValid = selectedCountry && businessIdea.trim() && budgetRange;

    return (
        <Fragment>
            {/* <PageHeading
                title={"BUSINESS PLAN AI"}
                description={
                    "Generate a comprehensive business plan tailored to your country, idea, and budget."
                }
                onInfoClick={() => setShowPdfModal(true)}
                infoTooltip="See sample business plan"
            /> */}

            <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="What you can do?">
                <ContentBusinessPlan />
            </SamplePdfModal>

            <div
                className="container pb-5"
                style={{
                    maxWidth: "872px",
                    paddingInline: "12px",
                    marginInline: "auto",
                }}
            >
                <div className="container">

                    {/* Credits section */}
                    <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                        <div>
                            {/* <div>
                                <button className="credits-button">
                                    CREDITS : {creditToLocalString}
                                </button>
                                <button
                                    className="buy-credits-button"
                                    onClick={() => navigate("/purchase")}
                                >
                                    BUY CREDITS
                                </button>
                                <button
                                    onClick={() => navigate("/usage")}
                                    className="money-exchange-button"
                                >
                                    <img src={moneyExchangeIcon} alt="usage" />
                                </button>
                            </div> */}
                            <p className="all-page-title all-page-gradient-text text-center my-4">BUSINESS PLAN AI</p>

                            <div className="credits-actions">

                                <button className="credits-button">
                                    CREDITS : {creditToLocalString}
                                </button>

                                <button
                                    className="buy-credits-button"
                                    onClick={() => navigate("/purchase")}
                                >
                                    BUY CREDITS
                                </button>

                                <button
                                    onClick={() => navigate("/usage")}
                                    className="money-exchange-button"
                                >
                                    <img src={moneyExchangeIcon} alt="usage" />
                                </button>

                                <button
                                    type="button"
                                    className="money-exchange-button"
                                    onClick={() => {
                                        setShowPdfModal(true);
                                    }}

                                >
                                    <img src={sampleIcon} alt="See sample video" />
                                </button>

                            </div>
                            <p
                                style={{ fontSize: "8px" }}
                                className="text-white mt-2 creditText text-center"
                            >
                                {credit} Credits  (USD {creditCostUSD.toFixed(2)} based on Credits Package 3)
                            </p>
                        </div>
                    </div>
                    <p style={{ fontSize: "10px" }} className="text-white text-md-center text-lg-center text-center mb-5 d-flex justify-content-center">This AI will be generated on our server and sent to your email, so you don't have to wait</p>

                    {/* Step 1: Country Selection */}
                    <div className="mb-4 mt-4">
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                            Country <span className="text-danger">*</span>
                        </label>
                        <select
                            className="w-100 business-plan-select text-white"
                            value={selectedCountry}
                            onChange={handleCountryChange}
                        >
                            <option value="">Select Country</option>
                            {COUNTRIES.map((country) => (
                                <option key={country} value={country}>
                                    {country}
                                </option>
                            ))}
                        </select>
                        {selectedCountry && currency && (
                            <div className="business-plan-budget-hint">
                                Currency:{" "}
                                <span className="business-plan-currency-badge">{currency}</span>
                            </div>
                        )}
                    </div>

                    {/* Step 2: Business Idea */}
                    <div className="mb-4">
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                            Business Idea <span className="text-danger">*</span>
                        </label>
                        <textarea
                            className="w-100 business-plan-textarea"
                            value={businessIdea}
                            // onChange={(e) => setBusinessIdea(e.target.value)}

                            onChange={(e) => {
                                const value = e.target.value;
                                setBusinessIdea(value);

                                if (promptTimeoutRef.current) {
                                    clearTimeout(promptTimeoutRef.current);
                                }

                                promptTimeoutRef.current = setTimeout(() => {
                                    checkBusinessIdeaPrompt(value);
                                }, 1500);
                            }}

                            placeholder="Describe your business idea in detail.."
                        />
                    </div>

                    {checkingPrompt && (
                        <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-light spinner-border-sm me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <span className="text-warning" style={{ marginLeft: "8px" }}>Generating suggestion...</span>
                        </div>
                    )}

                    {suggestedIdea && (
                        <div
                            onClick={() => setBusinessIdea(suggestedIdea)}
                            style={{
                                cursor: "pointer",
                                background: "#0b2d4d",
                                padding: "12px",
                                borderRadius: "10px",
                                marginBottom: "12px",
                                border: "1px solid #fff",
                            }}
                        >
                            <p className="mb-1 text-warning">Suggested Business Idea:</p>
                            <p className="mb-0 text-white">{suggestedIdea}</p>
                        </div>
                    )}

                    {/* Step 3: Startup Budget Range */}
                    <div className="mb-4">
                        <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                            Startup Budget Range <span className="text-danger">*</span>
                        </label>
                        <select
                            className="w-100 business-plan-select text-white"
                            value={budgetRange}
                            onChange={(e) => setBudgetRange(e.target.value)}
                        >
                            <option value="">Select Budget Range</option>
                            {BUDGET_RANGES.map((range, idx) => (
                                <option
                                    key={idx}
                                    value={`${range.min}-${range.max}`}
                                >
                                    {getBudgetLabel(range)}
                                </option>
                            ))}
                        </select>
                    </div>

                    <AiContentAudit checked={auditChecked} onChange={setAuditChecked} auditCreditCost={84} />

                    {/* Action Buttons */}
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        <Button
                            sx={{
                                padding: "8px 30px",
                                marginRight: "10px",
                                color: "#000",
                                background: "#fff",
                                "&:hover": { background: "#fff" },
                                "&:disabled": { background: "#fff" },
                            }}
                            onClick={() => {
                                handleClear();
                                setSuggestedIdea("");
                            }}
                            disabled={
                                (!businessIdea && !budgetRange) || isLoading
                            }
                            variant="contained"
                        >
                            Clear
                        </Button>
                        <Button
                            sx={{
                                padding: "8px 30px",
                                "&:disabled": { background: "gray" },
                            }}
                            onClick={handleGenerate}
                            className="generate-button text-white"
                            disabled={!isFormValid || isLoading}
                            variant="contained"
                        >
                            {isLoading ? "Processing..." : "Generate"}
                        </Button>
                    </div>

                    <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
                        While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        {isLoading && (
                            <div
                                className="spinner-border text-light"
                                role="status"
                                style={{ width: "4rem", height: "4rem" }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

